import { useContext } from "react";
import BlacklistManagementContext from "../context/BlacklistManagement";

const useBlacklistManagement = () => useContext(BlacklistManagementContext);

export default useBlacklistManagement;
